import { all, create } from 'mathjs'
import moment from 'moment'

const math = create(all)
math.import(
  {
    calculateDates: (start: string, end?: string, unit?: string) => {
      const mStart = moment(start)
      const mEnd = end ? moment(end) : moment() // default to today if end is undefined

      const years = mEnd.diff(mStart, 'years')
      mStart.add(years, 'years')

      const months = mEnd.diff(mStart, 'months')
      mStart.add(months, 'months')

      const days = mEnd.diff(mStart, 'days')

      if (unit === 'y') {
        if (typeof years === 'number' && !isNaN(years)) {
          return `${years} years`
        } else {
          return '--'
        }
      } else if (unit === 'ym') {
        if (
          typeof years === 'number' &&
          !isNaN(years) &&
          typeof months === 'number' &&
          !isNaN(months)
        ) {
          return `${years} years and ${months} months`
        } else {
          return '--'
        }
      } else if (
        unit === 'ymd' &&
        typeof years === 'number' &&
        !isNaN(years) &&
        typeof months === 'number' &&
        !isNaN(months) &&
        typeof days === 'number' &&
        !isNaN(days)
      ) {
        return `${years} years, ${months} months and ${days} days`
      } else {
        return '--'
      }
    },
    concat: (arr: { _data: string[] }) => {
      return arr?._data?.join(' ')
    },
    isMinor: (date: string) => {
      const mStart = moment(date)
      const age = moment().diff(mStart, 'years')
      return age < 18 ? 'Yes' : 'No'
    },
  },
  { override: true }
)

export const evaluateFormula = (
  formula: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  values: Record<string, any>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): any => {
  let expression = formula

  expression = expression.replace(/{(.*?)}/g, (_, field) => {
    if (!field) return 'null'

    const value = values[field]

    if (value === undefined) {
      if (['y', 'ym', 'ymd'].includes(field)) {
        return `"${field}"`
      }
      return 'null'
    }

    if (value === null || value === '') {
      return 'null'
    }

    if (
      formula.includes('calculateDates') &&
      ['y', 'ym', 'ymd'].includes(value)
    ) {
      return `"${value}"`
    }

    if (typeof value === 'string' && !isNaN(Number(value))) {
      return Number(value)
    }
    return typeof value === 'string' ? `"${value}"` : value
  })

  try {
    return math.evaluate(expression)
  } catch (error) {
    console.error('Formula evaluation error:', error)
    return ''
  }
}
